export default "__VITE_ASSET__Cesdet_v__"